export default {
  ARTICLE: 'article',
  CUSTOMER_SERVICE: 'customer-service'
};
